// @flow

import Game from '@/lib/game';

export default class {
  game: Game;
  stats: Stats;

  constructor(game: Game) {
    this.game = game;
  }

  calculate() {
    // 上手くまとめたいが、 flowtype が効かなくなるので愚直に書く
    const stats = {
      // ブナ (陰樹, d_tree1)
      beechTreesCount: 0,
      beechSeedTreesCount: 0,
      beechSproutTreesCount: 0,
      beechYoungTreesCount: 0,
      beechAdultTreesCount: 0,
      // スギ (陰樹, d_tree2)
      cedarTreesCount: 0,
      cedarSeedTreesCount: 0,
      cedarSproutTreesCount: 0,
      cedarYoungTreesCount: 0,
      cedarAdultTreesCount: 0,
      // イタヤカエデ (陰樹, d_tree3)
      mapleTreesCount: 0,
      mapleSeedTreesCount: 0,
      mapleSproutTreesCount: 0,
      mapleYoungTreesCount: 0,
      mapleAdultTreesCount: 0,
      // ケヤキ (陽樹, s_tree1)
      zelkovaTreesCount: 0,
      zelkovaSeedTreesCount: 0,
      zelkovaSproutTreesCount: 0,
      zelkovaYoungTreesCount: 0,
      zelkovaAdultTreesCount: 0,
      // クリ (陽樹, s_tree2)
      creTreesCount: 0,
      creSeedTreesCount: 0,
      creSproutTreesCount: 0,
      creYoungTreesCount: 0,
      creAdultTreesCount: 0,
      // ヤマザクラ (陽樹, s_tree3)
      cherryTreesCount: 0,
      cherrySeedTreesCount: 0,
      cherrySproutTreesCount: 0,
      cherryYoungTreesCount: 0,
      cherryAdultTreesCount: 0,
      // 木の総数 (種を除く)
      treesCount: 0,
    };

    for (let unitId in this.game.units) {
      const unit = this.game.units[Number(unitId)];

      if (!unit.isAlive()) continue;
      if (unit.template.type === 'weed1s') continue;

      switch (unit.template.type) {
        case 'd_tree1_seed':
          stats.beechSeedTreesCount++;
          break;
        case 'd_tree1_sprout':
          stats.beechSproutTreesCount++;
          break;
        case 'd_tree1_young':
          stats.beechYoungTreesCount++;
          break;
        case 'd_tree1_adult':
          stats.beechAdultTreesCount++;
          break;
        case 'd_tree2_seed':
          stats.cedarSeedTreesCount++;
          break;
        case 'd_tree2_sprout':
          stats.cedarSproutTreesCount++;
          break;
        case 'd_tree2_young':
          stats.cedarYoungTreesCount++;
          break;
        case 'd_tree2_adult':
          stats.cedarAdultTreesCount++;
          break;
        case 'd_tree3_seed':
          stats.mapleSeedTreesCount++;
          break;
        case 'd_tree3_sprout':
          stats.mapleSproutTreesCount++;
          break;
        case 'd_tree3_young':
          stats.mapleYoungTreesCount++;
          break;
        case 'd_tree3_adult':
          stats.mapleAdultTreesCount++;
          break;
        case 's_tree1_seed':
          stats.zelkovaSeedTreesCount++;
          break;
        case 's_tree1_sprout':
          stats.zelkovaSproutTreesCount++;
          break;
        case 's_tree1_young':
          stats.zelkovaYoungTreesCount++;
          break;
        case 's_tree1_adult':
          stats.zelkovaAdultTreesCount++;
          break;
        case 's_tree2_seed':
          stats.creSeedTreesCount++;
          break;
        case 's_tree2_sprout':
          stats.creSproutTreesCount++;
          break;
        case 's_tree2_young':
          stats.creYoungTreesCount++;
          break;
        case 's_tree2_adult':
          stats.creAdultTreesCount++;
          break;
        case 's_tree3_seed':
          stats.cherrySeedTreesCount++;
          break;
        case 's_tree3_sprout':
          stats.cherrySproutTreesCount++;
          break;
        case 's_tree3_young':
          stats.cherryYoungTreesCount++;
          break;
        case 's_tree3_adult':
          stats.cherryAdultTreesCount++;
          break;
      }

      stats.beechTreesCount =
        stats.beechSeedTreesCount +
        stats.beechSproutTreesCount +
        stats.beechYoungTreesCount +
        stats.beechAdultTreesCount;

      stats.cedarTreesCount =
        stats.cedarSeedTreesCount +
        stats.cedarSproutTreesCount +
        stats.cedarYoungTreesCount +
        stats.cedarAdultTreesCount;

      stats.cherryTreesCount =
        stats.cherrySeedTreesCount +
        stats.cherrySproutTreesCount +
        stats.cherryYoungTreesCount +
        stats.cherryAdultTreesCount;

      stats.creTreesCount =
        stats.creSeedTreesCount +
        stats.creSproutTreesCount +
        stats.creYoungTreesCount +
        stats.creAdultTreesCount;

      stats.mapleTreesCount =
        stats.mapleSeedTreesCount +
        stats.mapleSproutTreesCount +
        stats.mapleYoungTreesCount +
        stats.mapleAdultTreesCount;

      stats.zelkovaTreesCount =
        stats.zelkovaSeedTreesCount +
        stats.zelkovaSproutTreesCount +
        stats.zelkovaYoungTreesCount +
        stats.zelkovaAdultTreesCount;

      if (unit.template.type.match(/_seed$/) === null) {
        stats.treesCount++;
      }
    }

    this.stats = stats;
  }
}



// WEBPACK FOOTER //
// ./src/lib/stats_manager/stats_manager.js